export default __webpack_public_path__ + "static/media/pink_mohawk.e3bd4413.png";